import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert } from 'react-bootstrap';

function DeleteAccount() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!email.trim()) {
      setError('Please enter your email address.');
      return;
    }
    if (!isValidEmail(email.trim())) {
      setError('Please enter a valid email address.');
      return;
    }

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);
    }, 1500);
  };

  const handleReset = () => {
    setEmail('');
    setError('');
    setSubmitted(false);
  };

  return (
    <div style={{ backgroundColor: '#0f0f0f', minHeight: '100vh', color: '#fff', padding: '80px 0' }}>
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <div style={{
              background: '#1a1a1a',
              border: '1px solid #2a2a2a',
              borderRadius: 16,
              padding: '40px 32px',
              boxShadow: '0 10px 40px rgba(0,0,0,0.4)',
            }}>
              <div style={{ textAlign: 'center', marginBottom: 32 }}>
                <div style={{
                  width: 72, height: 72,
                  borderRadius: 18,
                  background: 'linear-gradient(135deg, #E8855A, #c96a3e)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 36, margin: '0 auto 20px',
                  boxShadow: '0 0 30px rgba(232,133,90,0.35)',
                }}>
                  🗑️
                </div>
                <h1 style={{ fontSize: 28, fontWeight: 800, letterSpacing: -0.3, marginBottom: 8 }}>
                  Delete Account
                </h1>
                <p style={{ fontSize: 15, color: '#a0a0a0', marginBottom: 0 }}>
                  Request permanent deletion of your account and associated data.
                </p>
              </div>

              {submitted ? (
                <Alert
                  variant="success"
                  style={{
                    background: 'rgba(40, 167, 69, 0.12)',
                    border: '1px solid rgba(40, 167, 69, 0.4)',
                    color: '#9be7a8',
                    borderRadius: 10,
                  }}
                >
                  <Alert.Heading style={{ fontSize: 18, color: '#9be7a8' }}>Request received</Alert.Heading>
                  <p style={{ marginBottom: 16, fontSize: 14 }}>
                    If an account exists with this email, it will be deleted within 24 hours.
                  </p>
                  <Button
                    variant="outline-light"
                    size="sm"
                    onClick={handleReset}
                    style={{ borderColor: '#3a3a3a', color: '#ccc' }}
                  >
                    Submit another request
                  </Button>
                </Alert>
              ) : (
                <Form onSubmit={handleSubmit} noValidate>
                  <Form.Group className="mb-3" controlId="deleteAccountEmail">
                    <Form.Label style={{ color: '#ccc', fontSize: 14, fontWeight: 500 }}>
                      Email address
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="you@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={loading}
                      isInvalid={!!error}
                      style={{
                        background: '#0f0f0f',
                        border: '1px solid #2a2a2a',
                        color: '#fff',
                        padding: '12px 14px',
                        borderRadius: 8,
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {error}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <p style={{ fontSize: 12, color: '#808080', marginBottom: 24 }}>
                    Enter the email tied to your account. We will process deletion within 24 hours.
                  </p>

                  <Button
                    type="submit"
                    disabled={loading}
                    style={{
                      width: '100%',
                      background: 'linear-gradient(135deg, #E8855A, #c96a3e)',
                      border: 'none',
                      padding: '12px',
                      fontWeight: 700,
                      borderRadius: 8,
                      fontSize: 15,
                    }}
                  >
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" role="status" className="me-2" />
                        Processing...
                      </>
                    ) : (
                      'Submit deletion request'
                    )}
                  </Button>
                </Form>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default DeleteAccount;
